export default IconSortAZ => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-sort-a-z" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16 8h4l-4 8h4" />
  <path d="M4 16v-6a2 2 0 1 1 4 0v6" />
  <path d="M4 13h4" />
  <path d="M11 12h2" />
</svg>`;